<template>
  <i :class="[iconClass, 'app-icon']"></i>
</template>

<script>
const iconMap = {
  account_balance_wallet: 'el-icon-wallet',
  ads_click: 'el-icon-aim',
  admin_panel_settings: 'el-icon-s-check',
  analytics: 'el-icon-data-analysis',
  arrow_back: 'el-icon-back',
  arrow_forward: 'el-icon-right',
  aspect_ratio: 'el-icon-full-screen',
  auto_awesome: 'el-icon-magic-stick',
  auto_fix_high: 'el-icon-magic-stick',
  bolt: 'el-icon-lightning',
  broken_image: 'el-icon-picture-outline',
  card_membership: 'el-icon-medal',
  check: 'el-icon-check',
  check_circle: 'el-icon-circle-check',
  close: 'el-icon-close',
  cloud_off: 'el-icon-cloudy-and-sunny',
  cloud_upload: 'el-icon-upload',
  content_copy: 'el-icon-document-copy',
  content_cut: 'el-icon-scissors',
  content_paste: 'el-icon-document-copy',
  dashboard_customize: 'el-icon-menu',
  delete_outline: 'el-icon-delete',
  delete_sweep: 'el-icon-delete-solid',
  description: 'el-icon-document',
  download: 'el-icon-download',
  drag_indicator: 'el-icon-rank',
  double_arrow: 'el-icon-d-arrow-right',
  edit: 'el-icon-edit',
  error: 'el-icon-warning-outline',
  expand_more: 'el-icon-arrow-down',
  event: 'el-icon-date',
  folder_open: 'el-icon-folder-opened',
  folder_shared: 'el-icon-folder',
  chevron_right: 'el-icon-arrow-right',
  gavel: 'el-icon-s-check',
  grid_view: 'el-icon-menu',
  group_add: 'el-icon-user-solid',
  help: 'el-icon-question',
  history: 'el-icon-time',
  home: 'el-icon-house',
  image: 'el-icon-picture-outline',
  inbox: 'el-icon-box',
  info: 'el-icon-info',
  inventory_2: 'el-icon-goods',
  key: 'el-icon-key',
  link: 'el-icon-link',
  lock: 'el-icon-lock',
  lock_reset: 'el-icon-refresh',
  login: 'el-icon-user',
  logout: 'el-icon-switch-button',
  manage_accounts: 'el-icon-setting',
  menu: 'el-icon-s-unfold',
  menu_book: 'el-icon-notebook-2',
  menu_open: 'el-icon-s-fold',
  mic: 'el-icon-microphone',
  monitoring: 'el-icon-monitor',
  movie: 'el-icon-video-camera',
  movie_edit: 'el-icon-video-camera',
  music_note: 'el-icon-headset',
  notes: 'el-icon-notebook-2',
  open_in_new: 'el-icon-top-right',
  password: 'el-icon-key',
  payments: 'el-icon-money',
  pending: 'el-icon-loading',
  person: 'el-icon-user',
  person_add: 'el-icon-user-solid',
  person_check: 'el-icon-user',
  phone: 'el-icon-mobile-phone',
  phone_iphone: 'el-icon-mobile-phone',
  photo_library: 'el-icon-picture',
  play_arrow: 'el-icon-video-play',
  play_circle: 'el-icon-video-play',
  progress_activity: 'el-icon-loading',
  receipt_long: 'el-icon-tickets',
  redeem: 'el-icon-present',
  rocket_launch: 'el-icon-position',
  save: 'el-icon-folder-checked',
  settings: 'el-icon-setting',
  share: 'el-icon-share',
  shopping_bag: 'el-icon-shopping-bag-1',
  smart_toy: 'el-icon-cpu',
  sms: 'el-icon-chat-dot-round',
  star: 'el-icon-star-on',
  star_border: 'el-icon-star-off',
  text_fields: 'el-icon-edit-outline',
  unfold_less: 'el-icon-arrow-up',
  unfold_more: 'el-icon-arrow-down',
  verified_user: 'el-icon-circle-check',
  video_file: 'el-icon-document',
  video_library: 'el-icon-video-camera-solid',
  video_settings: 'el-icon-set-up',
  water_drop: 'el-icon-water-cup',
  workspace_premium: 'el-icon-medal'
}

export default {
  name: 'AppIcon',
  props: {
    name: { type: String, default: '' }
  },
  computed: {
    iconClass() {
      if (this.name.indexOf('el-icon-') === 0) return this.name
      return iconMap[this.name] || 'el-icon-menu'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/AppIcon.vue